export const USERS_PLURAL_MAP = {
   '=0': '0 users',
   '=1': '1 user',
   other: '# users',
};
